import { useCallback, useEffect, useRef, useState } from 'react';

const useCountdown = ({ seconds }) => {
  const timeoutRef = useRef<number | undefined>();
  const [counter, setCounter] = useState<number>(seconds);
  const [isRunning, setIsRunning] = useState<boolean>(false);

  const startCountdown = useCallback(() => {
    timeoutRef.current = setInterval(() => {
      setCounter(prev => prev - 1);
    }, 1000);
    setIsRunning(true);
  }, []);

  const resetCountdown = useCallback(() => {
    setCounter(seconds);
  }, [seconds]);

  useEffect(() => {
    if (counter === 0) {
      setIsRunning(false);
      clearInterval(timeoutRef.current);
    }
  }, [counter]);

  useEffect(() => {
    return () => {
      if (!!timeoutRef.current) clearInterval(timeoutRef.current);
    };
  }, []);

  return {
    resetCountdown,
    startCountdown,
    isRunning,
    counter,
  };
};

export default useCountdown;
